<lpcr-navbar [displayTopBar]="false" [displayMobileMenu]="userContext.isConnected">
  <ng-template #items>
    @if (userContext.user$ | async; as user) {
      @if (user.isConnected) {
        <lpcr-navbar-item title="MON TABLEAU DE BORD" name="dashboard" route="/tableau-de-bord" />
        <lpcr-navbar-item title="MES DOCUMENTS" name="documents" route="/documents" />
        <lpcr-navbar-item title="ACTUALITÉS" name="dashboard" route="/actualites" />
        <lpcr-navbar-item title="Contactez-nous" name="contactezNous" route="/mon-compte/mes-contacts" />

        @if (user.isAdministrator) {
          <lpcr-navbar-item title="ADMINISTRATION" name="administration">
            <lpcr-navbar-item title="Utilisateurs" route="/administration/utilisateurs" />
            <lpcr-navbar-item title="Clients" route="/administration/clients" />
            <lpcr-navbar-item title="Actualités" route="/administration/actualites" />
            <lpcr-navbar-item title="FAQs" route="/administration/faqs" />
            <lpcr-navbar-item title="Documents" route="/administration/documents" />
            <lpcr-navbar-item title="Panneau d'affichage" route="/administration/affiches" />
          </lpcr-navbar-item>
        }
      }
    }
  </ng-template>
  <ng-template #rightItems>
    @if (userContext.user$ | async; as user) {
      @if (user.isConnected) {
        <button type="button" text="" title="" class="px-3 invisible lg:visible cursor-pointer"
          (click)="menu.toggleMenu($event)">
          <span class="hidden">Toggle user menu</span>
          <img alt="" src="assets/img/user-icon.svg" class="w-9 h-9">
        </button>
        <lpcr-user-menu #menu>
          <hr class="block lg:hidden pb-2 mx-12 border-slate-600/30 lg:pb-0 lg:mx-0" />
          <lpcr-user-menu-item title="Mon compte" [route]="['/mon-compte']" icon="assets/img/user-icon.svg" />
          <hr class="hidden lg:block" />
          <!-- <lpcr-user-menu-item title="Mes contacts" [route]="['/mon-compte/mes-contacts']"
            icon="assets/img/logo-no-text.svg" />
          <hr class="hidden lg:block" /> -->
          <lpcr-user-menu-item title="FAQ" [route]="['/mon-compte/faq']" icon="assets/img/question-icon.svg" />
          <hr class="hidden lg:block" />
          <div  class="text-center py-4 lg:py-2 bg-white">
            <div class="panneau-affichage-button text-gray-700 text-center cursor-pointer" id="menu-item-3" (click)="forceShowNoticeBoard()" (keydown.enter)="forceShowNoticeBoard()">
              Panneau d'affichage
            </div>
          </div>
          <hr class="hidden lg:block" />
          <div id="logout-button" class="text-center logout-button-container py-12 sm:py-2 bg-white">
            <div class="logout-button text-center cursor-pointer" id="menu-item-4" (click)="logout()">
              Déconnexion
            </div>
          </div>
        </lpcr-user-menu>
      }
    }
  </ng-template>
</lpcr-navbar>
<div class="decoration-flowers"></div>
<div class="decoration-logo"></div>

<lpcr-notice-board #noticeBoard />

<main class="relative flex justify-center overflow-y-hidden">
  <section class="container mt-8 mb-5 px-6">
    @if (isLoading) {
      <lpcr-loading-indicator />
    }
    @else {
      <router-outlet />
    }
  </section>

</main>


